<script>
	import { goto, ready } from '@roxi/routify';
	import { getData, getGETAPILink, postFormData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	function paymentRedirect() {
		let sessionLinkPromise = getData('stripe/get-checkout-session', {'hostURL': window.location.href});
		sessionLinkPromise.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				window.location.href = ret_json.url;
			} else {
				userStatErrorField = ret_json.error;
			}
		});
	}
	
</script>

<main class=background>
	<Navbar/>
	<div class="lg:mx-64 md:mx-32 sm:mx-10 mx-2 pb-20">
		<div class="mx-auto mt-10">
			<div class="max-w-xl mx-auto p-16 rounded-md shadow-lg bg-white bg-opacity-50">
				<p class="text-2xl font-semibold text-blue-900 mb-8">Edit User Info</p>
				<div class='flex flex-col space-y-4'>
					<button on:click={$goto('/change-password')}
					class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
					Change Password</button>
					<button on:click={$goto('/webauthn-options')}
					class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
					Register WebAuthn</button>
					<button on:click={$goto('/update-subscription')}
					class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
					Update Subscription Info</button>
					<button on:click={paymentRedirect}
					class="px-4 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
					Update Billing Information</button>
				</div>
				<button on:click={$goto('/dashboard')}
				class="mt-6 px-6 pb-2.5 pt-1.5 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
				Back</button>
			</div>
		</div>
		<Footer/>
	</div>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}
</style>